import { Axios } from './../shared/Axios';
import qs from 'qs';

class BannerService extends Axios {

    private static instance: BannerService;

    static get(): BannerService {
        if (!BannerService.instance) {
            BannerService.instance = new BannerService();
        }
        return BannerService.instance;
    }

    async getBanners(data: object): Promise<any> {
        return this.instance.get(`/admin/banner${qs.stringify(data, { addQueryPrefix: true })}`)
    }

    async updateBanner(data: object, id: number): Promise<any> {
        return this.instance.patch(`/admin/banner/${id}`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }

    async saveBanner(data: object): Promise<any> {
        return this.instance.post(`/admin/banner`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }

    async deleteBanner(id: number): Promise<any> {
        return this.instance.delete(`/admin/banner/${id}`)
    }




}


const bannerService = BannerService.get();

export { bannerService as BannerService }